/* global axios */

class ProductsAPI {
  get(accountId, params = {}) {
    return axios.get(`/api/v1/accounts/${accountId}/products`, { params });
  }

  show(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/products/${id}`);
  }

  create(accountId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/products`, { product: payload });
  }

  update(accountId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/products/${id}`, { product: payload });
  }

  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/products/${id}`);
  }

  // Images
  createImage(accountId, productId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/products/${productId}/images`, {
      product_image: payload,
    });
  }

  updateImage(accountId, productId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/products/${productId}/images/${id}`, {
      product_image: payload,
    });
  }

  deleteImage(accountId, productId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/products/${productId}/images/${id}`);
  }
}

export default new ProductsAPI();
